export const Errors = {
    license: 'Licentie kon niet geladen worden',
    pin: 'Pin automaat buiten gebruik',
    printer: 'Printer buiten gebruik'
};
